import React from 'react'
import Top from '../../components/common/Top'
import Lefter from '../../components/common/Lefter'
import ContractInfo from '../../components/common/ContractInfo'
import Apply from '../../components/common/Apply'
import CommonUploads from '../../components/common/Uploads/commonUploads'
import { Breadcrumb, Layout, Empty, Card, Col, Row, Tabs, Avatar, message, Modal, Form, Input, Button, Popconfirm, Spin, Divider, Select } from 'antd';
import { AntDesignOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { connect } from "react-redux";
import actionWays from '../../redux/actions';
import Footer from '../../components/common/Footer'
import moment from 'moment';
import { getCancelReserve, getCancelQueue, getMyTransactionLists, getMyQueueLists, getUpdateUser, checkCaptcha, forgetPassword, getMyReserveLists, getUserBillLists, getMyContracts, getTransactionDetailById, getCollectProjects, getMessages, sendNationCaptcha, getContractInfo, printTransaction, repairMaterials, getMyReletApplyList, applyReSignContract, cancelUserRelet, getApplyEvictionList, cancelApplyEviction, evictionElectronicSignature, evictionElectronicSignatureUrl, evictionElectronicSignatureUrls } from '../../utils/api'
import { idCardValid, isPassPortCard, isTWCard } from "../../config/identityCheck";
import '../../inphone.scss'
import FlowImg from '../../components/model/flowImg'
import ModalBox from '../../config/modalBox'
import Drawback from '../../config/drawback'
import TenantDirectMyList from '../../components/model/TenantDirectMyList'
import drawback from '../../config/drawback'
const { TabPane } = Tabs;
const { Content } = Layout;

class Personal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            transactionList: [],
            currest: '0',
            isedit: false,
            isChangeMobile: false,
            timer: 60,
            confirmLoading: false,
            visible: false,
            sonObj: {
                son: '0',
                transactionDetail: []
            },
            tapIndex: 0,
            loadings: false,
            isMaterial: false,
            loading: false,
            loadingss: true,
            isTap: false,
            showAsurname: false,
            showGoTos: false,
            showGoTo: false,
            secondsGoTo: 5,
            countdownText: 5 + 's',
            showImg: false,
            reletStartTime: '',
            reletType: '',
            indexAsurname: '',
            callbacksType: '0',
            showModalBox: false,
            showRenewalModalBox: false,
            renewalContract: null,
            showRenewalEditModalBox: false,
            reletApplyId: null,
            reletApplyItem: null,
            showDrawback: false,
            contractList: null,
            drawbackIdList: null,
            commonArr: [{ kind: '居住证', content: "", thumbnail: "", transactionAdditionType: '主申请人附件', operator: '', lackMaterialsFlag: '2', createTime: '', id: '', transactionId: '', transactionLivingHouseId: '', transactionPersonId: '' }, { kind: '社保缴纳证明', content: "", thumbnail: "", transactionAdditionType: '主申请人附件', operator: '', lackMaterialsFlag: '2', createTime: '', id: '', transactionId: '', transactionLivingHouseId: '', transactionPersonId: '' }]
        }
        this.timers = null
    }
    componentDidMount() {
        let typeTab = '0'
        console.log(this.props.history.location.query)
        if (this.props.history.location) {
            if (this.props.history.location.query) {
                this.setState({
                    selectableTab: this.props.history.location.query.tab
                })
                if (this.props.history.location.query.tab) {
                    typeTab = '1'
                    this.getMyTransactionList(this.props.history.location.query.tab)
                }
            }
        }
        console.log(typeTab)
        if (typeTab == '0') {
            this.getMyTransactionList('0')
        }
    }
    getMyTransactionList = async (value) => {
        this.setState({
            callbacksType: '0',
        })
        console.log(value)
        this.setState({
            selectableTab: value
        })
        if (value === '0') {
            this.setState({
                tabsDisabled: true,
            })
            let opts = {}
            opts.userId = this.props.userLoginInfo.id
            let data = await getMyTransactionLists('')
            if (data.code === 0) {
                let transactionList = data.data
                transactionList.forEach((item, index, data) => {
                    item.tapIndex = index
                    item.title = '受理编号\xa0\xa0' + (item.transactionNo ? item.transactionNo : '暂无受理编号') + '\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0有效期限\xa0\xa0' + (item.transactionValidStart ? moment(item.transactionValidStart).format('LL') : '暂无开始日期') + '\xa0\xa0-\xa0\xa0' + (item.transactionValidEnd ? moment(item.transactionValidEnd).format('LL') : '暂无结束日期')
                    item.transactionNoTitle = '受理编号'
                    item.transactionNo = item.transactionNo ? item.transactionNo : '暂无受理编号'
                    item.timesTitle = '有效期限'
                    item.times = (item.transactionValidStart ? moment(item.transactionValidStart).format('YYYY/MM/DD') : '暂无开始日期') + '—' + (item.transactionValidEnd ? moment(item.transactionValidEnd).format('YYYY/MM/DD') : '暂无结束日期')
                    if (item.lackMaterialsReason) {
                        this.setState({
                            lackMaterialsReason: item.lackMaterialsReason
                        })
                    }
                })
                this.setState({
                    transactionList: transactionList,
                    tabsDisabled: false,
                })
            }
        } else if (value === '1') {
            let opts = {}
            opts.userId = this.props.userLoginInfo.id
            let data = await getMyQueueLists('')

            if (data.code === 0) {
                let transactionList = data.data
                transactionList.forEach((item, index, data) => {
                    item.title = '提交时间\xa0\xa0' + (item.queueTime ? moment(item.queueTime).format('LL') : '暂无')
                    item.timesTitle = '提交时间'
                    item.times = (item.queueTime ? moment(item.queueTime).format('YYYY/MM/DD h:mm:ss') : '暂无开始日期')
                })
                this.setState({
                    transactionList: transactionList,
                })
            }
        }
        else if (value === '2') {
            let opts = {}
            opts.userId = this.props.userLoginInfo.id
            let data = await getMyReserveLists('')
            if (data.code === 0) {
                let transactionList = data.data
                transactionList.forEach((item, index, data) => {
                    item.title = '提交时间\xa0\xa0' + (item.reserveTime ? moment(item.reserveTime).format('LL') : '暂无')
                    item.timesTitle = '提交时间'
                    item.times = (item.reserveTime ? moment(item.reserveTime).format('YYYY/MM/DD h:mm:ss') : '暂无开始日期')
                })
                this.setState({
                    transactionList: transactionList,
                })
            }
        }
        else if (value === '3') {
            let opts = {}
            opts.userId = this.props.userLoginInfo.id
            opts.cardNo = this.props.userLoginInfo.idno
            opts.billStatus = '0'
            opts.pageIndex = '0'
            opts.pageSize = '20'
            let data = await getUserBillLists(opts)

            if (data.code === 0) {

                let transactionList = data.data.pageContent
                transactionList.forEach((item, index, data) => {
                    item.title = '应付日期\xa0\xa0' + (item.collectionPeriod ? item.collectionPeriod : '暂无') + '\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0账单周期\xa0\xa0' + (item.billStartTime ? item.billStartTime : '暂无开始日期') + '\xa0\xa0-\xa0\xa0' + (item.billEndTime ? item.billEndTime : '暂无结束日期')
                    item.copeWithTitle = '应付日期'
                    item.copeWith = (item.collectionPeriod ? item.collectionPeriod : '暂无开始日期')
                    item.timesTitle = '账单周期'
                    item.times = (item.billStartTime ? moment(item.billStartTime).format('YYYY/MM/DD') : '暂无开始日期') + '—' + (item.billEndTime ? moment(item.billEndTime).format('YYYY/MM/DD') : '暂无结束日期')
                })
                this.setState({
                    transactionList: transactionList,
                })
            }
        }
        else if (value === '4') {

            let data = await getMyContracts('')
            if (data.code === 0) {
                let transactionList = data.data
                transactionList.forEach((item, index, data) => {
                    const date1 = moment().add(-1, 'days');
                    const date2 = moment(item.contractEndDate);
                    const isFullMonth = date1.clone().add(1, 'months').isSameOrBefore(date2);
                    item.isFullMonth = isFullMonth
                    item.title = '合同号\xa0\xa0' + (item.contractNo ? item.contractNo : '暂无') + '\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0合同周期\xa0\xa0' + (item.contractStartDate ? moment(item.contractStartDate).format('LL') : '暂无开始日期') + '\xa0\xa0-\xa0\xa0' + (item.contractEndDate ? moment(item.contractEndDate).format('LL') : '暂无结束日期')
                    item.contractNoTitle = '合同号码'
                    item.contractNo = item.contractNo ? item.contractNo : '暂无'
                    item.timesTitle = '合同周期'
                    item.times = (item.contractStartDate ? moment(item.contractStartDate).format('YYYY/MM/DD') : '暂无开始日期') + '—' + (item.contractEndDate ? moment(item.contractEndDate).format('YYYY/MM/DD') : '暂无结束日期')
                })
                console.log(transactionList);

                this.setState({
                    transactionList: transactionList,
                })
            }
        }
        //我的收藏打开后续 value+1
        // else if (value === '5') {
        //     let opts = {}
        //     opts.projectNo = this.props.userLoginInfo.projectNo ? this.props.userLoginInfo.projectNo : ''
        //     opts.userId = this.props.userLoginInfo.id
        //     let data = await getCollectProjects(opts)
        //     if (data.code === 0) {
        //         if (!!data.data) {
        //             let transactionList = data.data
        //             this.setState({
        //                 transactionList: transactionList,
        //             })
        //         }

        //     }
        // }
        else if (value === '5') {
            let opts = {}
            opts.userId = this.props.userLoginInfo.id
            opts.status = '2'
            opts.pageIndex = '0'
            opts.pageSize = '20'
            let data = await getMessages(opts)
            if (data.code === 0) {
                if (!!data.data) {
                    let transactionList = data.data.pageContent

                    this.setState({
                        transactionList: transactionList,
                    })
                }

            }
        } else if (value === '6') {
            this.setState({
                transactionList: [],
            })
        } else if (value === '7') {
            console.log('this.props.userLoginInfo', this.props.userLoginInfo);
            this.setState({
                transactionList: [this.props.userLoginInfo],
            })
        }
        this.setState({
            currest: value,
            sonObj: {
                son: '0'
            }
        })
    }
    // 重设密码
    setPassword = async (value) => {
        const opts = {}
        opts.captcha = value.research
        opts.mobile = value.mobile
        let list = await checkCaptcha(opts)
        if (list.code === 0) {
            clearInterval(this.timers)
            let objs = {}
            objs.mobile = value.mobile
            objs.loginPwd = value.loginPwd
            objs.code = value.research
            let data = await forgetPassword(objs)
            if (data.code === 0) {
                message.success('密码修改成功')
                this.closePassword()
                this.setState({
                    timer: 60
                })
                this.props.saveLoginInfo(null);
                setTimeout(() => {
                    this.setState({
                        loginLoading: false,
                        personal: '0'
                    })
                })
            } else {
                message.error(data.message)
            }
        } else {
            message.error('验证码不可使用')
        }
    }
    closePassword = () => {
        this.setState({
            isModalVisible: true,
            isChangePassword: false
        })
    }
    callback = (e) => {
        let opts = {}
        opts.userId = this.props.userLoginInfo.id
        opts.cardNo = this.props.userLoginInfo.idno
        opts.billStatus = e
        opts.pageIndex = '0'
        opts.pageSize = '20'
        let data = getUserBillLists(opts)
        data.then(res => {
            if (res.code === 0) {
                let transactionList = res.data.pageContent
                if (Object.keys(transactionList).length > 0) {
                    transactionList.forEach((item, index, data) => {
                        item.title = '应付日期\xa0\xa0' + (item.collectionPeriod ? item.collectionPeriod : '暂无') + '\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0账单周期\xa0\xa0' + (item.billStartTime ? item.billStartTime : '暂无开始日期') + '\xa0\xa0-\xa0\xa0' + (item.billEndTime ? item.billEndTime : '暂无结束日期')
                        item.copeWithTitle = '应付日期'
                        item.copeWith = (item.collectionPeriod ? item.collectionPeriod : '暂无开始日期')
                        item.timesTitle = '账单周期'
                        item.times = (item.billStartTime ? moment(item.billStartTime).format('YYYY/MM/DD') : '暂无开始日期') + '—' + (item.billEndTime ? moment(item.billEndTime).format('YYYY/MM/DD') : '暂无结束日期')
                    })
                }
                this.setState({
                    transactionList: transactionList,
                })
            }
        })
    }
    callbacks = (e) => {
        this.setState({
            callbacksType: e,
            visible: false
        })
        if (e == '0') {
            // getMyTransactionLists
            this.getMyTransactionList('0')
        }
        if (e == '1') {
            this.setState({
                tabsDisabled: true,
            })
            let data = getMyReletApplyList({ idno: this.props.userLoginInfo.idno })
            data.then(res => {
                if (res.code === 0) {
                    let transactionList = res.data
                    if (Object.keys(transactionList).length > 0) {
                        transactionList.forEach((item, index, data) => {
                            item.title = '申请日期\xa0\xa0' + (item.reletApplyDate ? moment(item.reletApplyDate).format('LL') : '暂无')
                            //  + '\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0续租周期\xa0\xa0' + (item.reletStartTime ? moment(item.reletStartTime).format('LL') : '暂无申请日期') + '\xa0\xa0-\xa0\xa0' + (item.reletEndTime ? moment(item.reletEndTime).format('LL') : '暂无结束日期')
                            item.copeWithTitle = '申请日期'
                            item.copeWith = (item.reletApplyDate ? moment(item.reletApplyDate).format('LL') : '暂无申请日期')
                            // item.timesTitle = '续租周期'
                            // item.times = (item.reletStartTime ? moment(item.reletStartTime).format('YYYY/MM/DD') : '暂无申请日期') + '—' + (item.reletEndTime ? moment(item.reletEndTime).format('YYYY/MM/DD') : '暂无结束日期')
                        })
                    }
                    this.setState({
                        transactionList: transactionList,
                        tabsDisabled: false,
                    })
                }
            })
        }
        if (e == '2') {
            this.setState({
                tabsDisabled: true,
            })
            let data = getApplyEvictionList({ idNo: this.props.userLoginInfo.idno, current: 0, pageSize: 100 })
            data.then(res => {
                if (res.code === 0) {
                    let transactionList = res.data.pageContent
                    if (Object.keys(transactionList).length > 0) {
                        transactionList.forEach((item, index, data) => {
                            console.log(item);

                            item.title = '申请日期\xa0\xa0' + (item.applyTime ? moment(item.applyTime).format('LL') : '暂无') + '\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0合同周期\xa0\xa0' + (item.contractPeriod ? item.contractPeriod : '暂无合同周期')
                            item.copeWithTitle = '申请日期'
                            item.copeWith = (item.applyTime ? moment(item.applyTime).format('LL') : '暂无申请日期')
                            item.timesTitle = '合同周期'
                            item.times = (item.contractPeriod ? item.contractPeriod : '暂无合同周期')
                        })
                    }
                    this.setState({
                        transactionList: transactionList,
                        tabsDisabled: false,
                    })
                }
            })
        }
    }
    cancelAsurname = async (id, legacy) => {
        this.setState({
            confirmLoading: true
        })
        const _self = this
        const data = await cancelUserRelet({
            id,
            legacy: legacy != null ? legacy : false,
        })
        if (data.code == 0) {
            _self.callbacks('1')
            message.success('操作成功')
        } else {
            message.error(data.message)
        }
        this.setState({
            confirmLoading: false,
            visible: false
        })
        console.log(data)
    }
    calcelFun = async (id) => {
        this.setState({
            confirmLoading: true
        })
        const _self = this
        const data = await cancelApplyEviction({ id: id, operator: this.props.userLoginInfo.username })
        if (data.code == 0) {
            _self.callbacks('2')
            message.success('操作成功')
        } else {
            message.error(data.message)
        }
        this.setState({
            confirmLoading: false,
        })
    }
    handleCancels = () => {
        this.setState({
            visible: false
        })
    }
    handleOk = async (id) => {
        this.setState({
            confirmLoading: true
        })
        const _self = this
        const data = await getCancelQueue({ id: id })
        if (data.code == 0) {
            _self.getMyTransactionList('1')
            message.success('操作成功')
        } else {
            message.error(data.message)
        }
        this.setState({
            confirmLoading: false,
            visible: false
        })
        console.log(data)
    }
    cancelReserve = async (id) => {
        this.setState({
            confirmLoading: true
        })
        const _self = this
        const data = await getCancelReserve({ id: id })
        if (data.code == 0) {
            _self.getMyTransactionList('2')
            message.success('操作成功')
        } else {
            message.error(data.message)
        }
        this.setState({
            confirmLoading: false,
            visible: false
        })
        console.log(data)
    }
    showPopconfirm = () => {
        this.setState({
            visible: true
        })
    }
    showContractInfo = (contractNo) => {
        this.setState({
            sonObj: {
                son: '1'
            },
            loadings: true
        })
        this.contractInfo(contractNo)
    }
    contractInfo = async (contractNo) => {
        let opts = {
            contractNo: contractNo
        }
        let data = await getContractInfo(opts)
        if (data.code == 0) {
            let contractInfos = data.data
            console.log(contractInfos);
            this.setState({
                sonObj: {
                    son: '1',
                    contractInfos: contractInfos
                }
            }, () => {
                this.setState({
                    loadings: false
                })
            })
        }
    }
    showApply = (id) => {
        this.setState({
            sonObj: {
                son: '2'
            },
            loadings: true
        })
        this.transactionDetailById(id)

    }
    transactionDetailById = async (id) => {
        let opts = {
            id: id
        }
        let data = await getTransactionDetailById(opts)
        if (data.code == 0) {
            let transactionDetail = data.data
            if (transactionDetail.registeredType.slice(0, 2) !== '上海' && transactionDetail.registeredType !== '本市' && !transactionDetail.holdLivingCardYear) {
                if (transactionDetail.applyAttruble == '个人') {
                    transactionDetail.holdLivingCardYear = '是'
                } else if (transactionDetail.applyAttruble == '单位') {
                    transactionDetail.holdLivingCardYear = '否'
                }
            }
            console.log(transactionDetail);
            this.setState({
                sonObj: {
                    son: '2',
                    transactionDetail: transactionDetail
                }
            }, () => {
                this.setState({
                    loadings: false
                })
            })
        }
    }
    printTransaction = (item) => {
        let id = item.id
        let registeredAddress = ''
        console.log(item);
        // {transactionDetail.province}{transactionDetail.city}{transactionDetail.district}{transactionDetail.registeredAddress}
        // JSON.parse(transactionDetail.province)}{transactionDetail.registeredAddress
        if (item.city) {
            registeredAddress = (item.province ? item.province : '') + item.city + item.district + item.registeredAddress
        } else {
            // registeredAddress = item.province ? JSON.parse(item.province)[0] + JSON.parse(item.province)[1] + item.registeredAddress : item.registeredAddress
            registeredAddress = (item.province ? JSON.parse(item.province).join("") : '') + item.registeredAddress
        }
        console.log(registeredAddress);
        this.getPrintTransaction(id, registeredAddress)
    }
    getPrintTransaction = async (id, registeredAddress) => {
        // console.log(id);
        // console.log(registeredAddress);
        let opts = {
            id: id,
            registeredAddress: registeredAddress
        }
        let data = await printTransaction(opts)
        if (data.code == 0) {
            console.log(data.data);
            window.open(data.data)
        }
    }
    getProjectDetail = (p) => {
        let projectName = p.projectName, projectNo = p.projectNo
        this.props.history.push({ pathname: '/belows', query: { projectName: projectName, projectNo: projectNo } })
    }
    getChangeSon = (son) => {
        this.setState({
            sonObj: {
                son: son
            }
        })
    }
    getChangeSons = (son) => {
        this.setState({
            sonObj: {
                son: son
            }
        })
    }
    setCommonImages = (img, list, imgTmp) => {
        console.log(img);
        console.log(list);
        console.log(this.state.jzzList);
        console.log("this.state.sbList", this.state.sbList);
        img = img.toString()
        const { commonArr, jzzList, sbList } = this.state
        if (list.kind == '居住证') {
            commonArr[0].content = img.toString()
            commonArr[0].thumbnail = imgTmp.toString()
            commonArr[0].createTime = jzzList.createTime
            commonArr[0].id = jzzList.id
            commonArr[0].transactionId = jzzList.transactionId
            commonArr[0].transactionLivingHouseId = jzzList.transactionLivingHouseId
            commonArr[0].transactionPersonId = jzzList.transactionPersonId
        }
        if (list.kind == '社保缴纳证明') {
            commonArr[1].content = img.toString()
            commonArr[1].thumbnail = imgTmp.toString()
            commonArr[1].createTime = sbList.createTime
            commonArr[1].id = sbList.id
            commonArr[1].transactionId = sbList.transactionId
            commonArr[1].transactionLivingHouseId = sbList.transactionLivingHouseId
            commonArr[1].transactionPersonId = sbList.transactionPersonId
        }
        this.setState({
            commonArr: commonArr
        })
        console.log(this.state.commonArr);
        this.setState({
            jzImages: img
        })
    }
    repairMaterials = async () => {
        const { commonArr } = this.state
        console.log("🚀 ~ file: index.js:460 ~ Personal ~ repairMaterials= ~ this.state:", this.state)
        console.log(commonArr);
        let arr = []
        for (let i in commonArr) {
            commonArr[i].operator = this.props.userLoginInfo.idno
            // , createTime: '', id: '', transactionId: '', transactionLivingHouseId: '', transactionPersonId: ''
        }
        if (this.state.lackMaterialsFlag == '1') {
            arr.push(commonArr[0])
        }
        if (this.state.lackMaterialsFlag == '2') {
            arr.push(commonArr[1])
            if (arr[0].content == "") {
                message.error("请全部上传");
                return;
            }
        }
        if (this.state.lackMaterialsFlag == '3') {
            arr.push(commonArr[0])
            arr.push(commonArr[1])
            if (arr[0].content == "" && arr[1].content == "") {
                message.error("请全部上传");
                return;
            }

        }
        console.log(
            "🚀 ~ file: index.js:492 ~ Personal ~ repairMaterials= ~ arr:",
            arr
        );
        console.log("🚀 ~ file: index.js:483 ~ Personal ~ repairMaterials= ~ arr:", arr)
        // return;
        let data = await repairMaterials(arr)
        if (data?.code == 0) {
            message.success('上传成功')
            console.log(data.data);
            this.getMyTransactionList('0')
            this.setState({
                isMaterial: false
            })
        } else {
            message.error(data?.message)
        }
    }
    showMaterialMakeupBox = async (item) => {
        let id = item.id
        let lackMaterialsFlag = item.lackMaterialsFlag
        console.log(this.props.userLoginInfo.idno);
        this.setState({
            isMaterial: true,
            loadingss: false,
            lackMaterialsFlag: lackMaterialsFlag
        })
        let opts = {
            id: id
        }
        let data = await getTransactionDetailById(opts)
        if (data.code == 0) {
            console.log(data.data);
            if (data.data.transactionAdditionList) {
                data.data.transactionAdditionList.map((item, index) => {
                    if (item.kind == '居住证') {
                        console.log(item.content);
                        this.setState({
                            jzzList: item,
                            jzzImages: item.content,
                            jzzImagesTmp: item.thumbnail
                        })
                    }
                    if (item.kind == '社保缴纳证明') {
                        this.setState({
                            sbList: item,
                            sbImages: item.content,
                            sbImagesTmp: item.thumbnail
                        })
                    }
                })
            }
            // console.log(this.state.jzhImages);
        }
        setTimeout(() => {
            this.setState({
                loadingss: true
            })
        }, 100)
    }
    getTransactionDetailByIds = (id) => {
        if (this.props.userLoginInfo.blacklisted == '1') {
            message.error('很抱歉，您无权限')
            return
        }
        this.props.history.push({ pathname: '/areatoraise', query: { id: id, type: '修改' } })
    }
    getExtra = (currest, item) => {
        console.log(item);
        return (
            // currest == '1'?<Popconfirm
            //     title="我的登记测试数据，等客户提供"
            //     // description="Are you sure to delete this task?"
            //     okText="确认"
            //     showCancel={false}
            //     icon=''
            // >
            //     <QuestionCircleOutlined style={{ fontSize: '18px', color: 'red' }} />
            // </Popconfirm>:currest == '2'?<Popconfirm
            //     title="我的预约测试数据，等客户提供"
            //     // description="Are you sure to delete this task?"
            //     okText="确认"
            //     showCancel={false}
            //     icon=''
            // >
            //     <QuestionCircleOutlined style={{ fontSize: '18px', color: 'red' }} />
            // </Popconfirm>:<></>
            currest == '1' || currest == '2' || item.reletType == '正常续租' || item.reletType == '六年期内过渡' ? <FlowImg /> : null
        )
    }
    //资格证、登记、预约、支付、合同
    tableBody = (item, index) => {
        console.log(item);

        const contractStatus = (e) => {
            switch (e) {
                case 1:
                    return '预签'
                    break;
                case 2:
                    return '签约'
                    break;
                case 21:
                    return '在租'
                    break;
                case 3:
                    return '退房'
                    break;
                case 30:
                    return '退房审核'
                    break;
                case 31:
                    return '退款'
                    break;
                case 32:
                    return '退款'
                    break;
                case 33:
                    return '退款'
                    break;
                case 34:
                    return '退款'
                    break;
                case 35:
                    return '退款'
                    break;
                case 36:
                    return '退款'
                    break;
                case 37:
                    return '退款'
                    break;
                case 4:
                    return '完结'
                    break;
                case 50:
                    return '申续申请'
                    break;
                case 5:
                    return '完结'
                    break;
                case 44:
                    return '删除'
                    break;
            }
        }
        const { currest } = this.state
        console.log(currest);

        const colorList = ['lv', 'hei', 'hui']
        const dt_1 = ['资格证申请', '小区名称', '小区名称', '小区名称', '小区名称']
        const dt_2 = ['申请类型', '户型意向', '房号', '房号', '房号']
        const dt_3 = ['申请属性', '登记名次/登记人数', '预约时间', '应付金额', '合同属性']
        const dt_4 = [{
            key: item.checkStatus === '驳回' ? '已驳回' : item.progress,
            color: item.progress === '成功' ? 'lv' : item.progress === '失败' ? 'hui' : 'hei',
            dt_1: item.firstApply === '1' ? '首次申请' : item.firstApply === '0' ? '复核' : '暂无数据',
            dt_2: item.applyType ? item.applyType : '暂无数据',
            dt_3: item.applyAttruble ? item.applyAttruble : '暂无数据',
            keys: item.evictionStatus,
            colors: item.evictionStatus === '待审核' && 'cheng' ||
                item.evictionStatus === '已取消' && 'hui' ||
                item.evictionStatus === '已审核' && 'lan' ||
                item.evictionStatus === '发起签章' && 'lan' ||
                item.evictionStatus === '签章中' && 'lan' ||
                item.evictionStatus === '签章成功' && 'lv',
        }, {
            key: item.status,
            color: item.status === '登记成功' ? 'lv' : item.status === '已登记' ? 'hei' : 'hui',
            dt_1: item.projectName,
            dt_2: item.houseType + '室户',
            dt_3: item.queuingNum ? item.queuingNum + '/' + item.totalQueuingNum : '暂无数据',
        }, {
            key: item.status,
            color: item.status === '预约成功' ? 'lv' : item.status === '预约中' ? 'hei' : 'hui',
            dt_1: item.projectName,
            dt_2: item.houseName,
            dt_3: item.reserveTime ? moment(item.reserveTime).format('LL') : '暂无数据',
        }, {
            key: item.billStatus === '0' ? '未缴费' : '已缴费',
            color: item.billStatus === '待支付' ? 'lv' : 'hong',
            dt_1: item.projectName,
            dt_2: item.houseNo,
            dt_3: item.billAmount ? item.billAmount : '暂无数据',
        }, {
            key: contractStatus(Number(item.contractStatus)),
            color: item.contractStatus === '21' || item.contractStatus === '2' ? 'lv' : 'hui',
            dt_1: item.house !== undefined ? item.house.projectName : '暂无',
            dt_2: item.house !== undefined ? item.house.houseNo : '暂无',
            dt_3: item.contractAttribute === '01' || item.contractAttribute === '03' ? '个人' : '单位',
        }]
        const { visible, confirmLoading, tapIndex, isMaterial, jzhImages, loadingss, jzzImages, sbImages, callbacksType } = this.state
        console.log(callbacksType);

        return (
            <div style={{ width: '100%' }} key={index}>
                <Col span={24} className="setNone">
                    {this.state.sonObj.son == '0' ?
                        <Card title={item.title} extra={this.getExtra(currest, item)} bordered={true} style={{ border: '1px solid #A0B5FB' }} headStyle={{ borderBottom: '1px solid #A0B5FB', padding: '0 24px', background: '#F3F6FF', color: '#999999', fontSize: '16px' }}>
                            <Row>
                                {/* 大屏左边 */}
                                {callbacksType == '0' ?
                                    <Col span={4} style={{ borderRight: '1px solid #DCE5FF', textAlign: 'center', lineHeight: '100px', fontSize: '26px' }} className={dt_4[currest].color}>
                                        <span>{dt_4[currest].key}</span>
                                    </Col> : callbacksType == '1' ?
                                        <Col span={4} style={{ borderRight: '1px solid #DCE5FF', textAlign: 'center', lineHeight: '100px', fontSize: '26px' }} className={item.status === '申请中' ? 'lan' : item.status === '已签约' ? 'lv' : (item.status === '已驳回' || item.status === '驳回') ? 'hong' : 'hui'}>
                                            <span>{item.status}</span>
                                        </Col> : callbacksType == '2' ?
                                            <Col span={4} style={{ borderRight: '1px solid #DCE5FF', textAlign: 'center', lineHeight: '100px', fontSize: '26px' }} className={dt_4[currest].colors}>
                                                <span>{dt_4[currest].keys}</span>
                                            </Col> : null}
                                <Col span={12} style={{ borderRight: '1px solid #DCE5FF' }}>
                                    {callbacksType == '0' ?
                                        <Row style={{ fontSize: '16px', textAlign: 'center', padding: '21px 10px' }} gutter={[0, 8]}>
                                            <Col span={8} className='hui'>{dt_1[currest]}</Col>
                                            <Col span={8} className='hui'>{dt_2[currest]}</Col>
                                            <Col span={8} className='hui'>{dt_3[currest]}</Col>
                                            <Col span={8} className='hei'>{dt_4[currest].dt_1}</Col>
                                            <Col span={8} className='hei'>{dt_4[currest].dt_2}</Col>
                                            <Col span={8} className='hei'>{dt_4[currest].dt_3}</Col>
                                        </Row> : callbacksType == '1' ?
                                            <Row style={{ fontSize: '16px', textAlign: 'center', padding: '21px 10px' }} gutter={[0, 8]}>
                                                <Col span={8} className='hui'>续租类型</Col>
                                                <Col span={8} className='hui'>续租月份</Col>
                                                <Col span={8} className='hui'>续租合同类型</Col>
                                                <Col span={8} className='hei'>{item.reletType ? item.reletType : '暂无数据'}</Col>
                                                <Col span={8} className='hei'>{item.reletMonth ? item.reletMonth + '月' : '暂无数据'}</Col>
                                                <Col span={8} className='hei'>{this.formatReletContractAttribute(item)}</Col>
                                            </Row> : callbacksType == '2' ?
                                                <Row style={{ fontSize: '16px', textAlign: 'center', padding: '21px 10px' }} gutter={[0, 8]}>
                                                    <Col span={8} className='hui'>退租类型</Col>
                                                    <Col span={8} className='hui'>计划退租日</Col>
                                                    <Col span={8} className='hui'>退租理由</Col>
                                                    <Col span={8} className='hei'>{item.evictionType ? item.evictionType : '暂无数据'}</Col>
                                                    <Col span={8} className='hei'>{item.applyEvictionDate ? item.applyEvictionDate : '暂无数据'}</Col>
                                                    <Col span={8} className='hei' style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '150px' }}>
                                                        <span title={item.evictionReason ? item.evictionReason : '暂无数据'}>{item.evictionReason ? item.evictionReason : '暂无数据'}</span>
                                                    </Col>
                                                </Row> : null}
                                </Col>
                                <Col span={8} style={{ textAlign: 'center', lineHeight: '100px' }}>
                                    {/* <div><a href="/#">查看详情</a></div> */}
                                    {currest == '1' ? (item.status == '已登记') || (item.status == '登记成功' && item.reserveStatus == '') ? <div>
                                        <Popconfirm
                                            title="取消登记将重新进行登记,是否确认取消?"
                                            onConfirm={() => { tapOnce(this.handleOk, item.id) }}
                                            // onCancel={() => { this.handleCancels() }}
                                            // visible={visible}
                                            okButtonProps={{ loading: confirmLoading }}
                                            okText="确定"
                                            cancelText="取消"
                                        >
                                            <a href="#" onClick={() => { this.showPopconfirm() }}>取消登记</a>
                                        </Popconfirm>
                                        {/* <a onClick={() => { this.setState({ showModalBox: true, ModalBoxId: item.id }) }} style={{ marginLeft: '10px' }}>
                                            补全信息
                                        </a> */}
                                        {item.status == '登记成功' && item.reserveStatus == '' ?
                                            <a onClick={() => {
                                                let p = { projectName: item.projectName, projectNo: item.projectNo }
                                                tapOnce(this.getProjectDetail, p)

                                            }}>&nbsp;预约看房</a> : null}
                                    </div> : null : null}
                                    {currest == '2' ? item.status == '预约中' ? <div>
                                        <Popconfirm
                                            title="取消预约视为您放弃本套房源及取消您目前的登记状态，如需选择其他房源，需重新登记轮候，请谨慎操作。"
                                            onConfirm={() => { tapOnce(this.cancelReserve, item.id) }}
                                            // onCancel={() => { this.handleCancels() }}
                                            // visible={visible}
                                            okButtonProps={{ loading: confirmLoading }}
                                            okText="确定"
                                            cancelText="取消"
                                        >
                                            <a href="#" onClick={() => { this.showPopconfirm() }}>取消预约</a>
                                        </Popconfirm>
                                    </div> : null : null}
                                    {currest == '4' ? <div>
                                        <a onClick={() => { tapOnce(this.showContractInfo, item.contractNo) }}>查看详情</a>
                                        {!item.reletFlag ? <a onClick={() => { this.openRenewalApplyModalBox(item) }} style={{ marginLeft: '10px' }}>续租申请</a> : null}
                                        {(item.contractStatus == '2' || item.contractStatus == '21') && (!item.evictionStatus || item.evictionStatus == '已取消') && item.isFullMonth && !item.reletFlag ? <a onClick={() => {
                                            this.setState({ showDrawback: true, contractList: item });
                                        }} style={{ marginLeft: '10px' }}>申请退租</a> : null}
                                    </div> : null}
                                    {currest == '0' ?
                                        callbacksType == '0' ?
                                            <div>
                                                <a onClick={() => { tapOnce(this.showApply, item.id) }}>查看详情</a>
                                                {/* <ModalBox /> */}
                                                {/* {item.perfectStatus == '0' ? <a onClick={() => { this.setState({ showModalBox: true, ModalBoxId: item.id }) }} style={{ marginLeft: '10px' }}>
                                                    补全信息
                                                </a> : null} */}
                                                {item.checkStatus == '驳回' ? <a onClick={() => {
                                                    this.getTransactionDetailByIds(item.id)
                                                }}><Divider type="vertical" />修改</a> : null}
                                                {item.progress == '成功' ? <a href={item.addition} style={{ marginLeft: '10px' }} target='_blank'>下载</a> :
                                                    null}
                                                {(item.progress == '已复核' || item.progress == '已上传' || item.progress == '成功') && item.checkStatus != '驳回' ?
                                                    <a onClick={() => { tapOnce(this.printTransaction, item) }} style={{ marginLeft: '10px' }}>打印</a> :
                                                    null}
                                                {(item.lackMaterialsFlag == '1' || item.lackMaterialsFlag == '2' || item.lackMaterialsFlag == '3') && item.smsCount > 0 && item.progress != '失败' ? <a onClick={() => { tapOnce(this.showMaterialMakeupBox, item) }} style={{ marginLeft: '10px' }} target='_blank'>补材料</a> :
                                                    null}
                                            </div> : callbacksType == '1' ?
                                                <div>
                                                    {item.status == '申请中' || (item.status == '驳回' && item.legacy == false) ? <a onClick={() => { this.showAsurnameBox(item, index) }}>修改</a> : null}
                                                    {item.status == '申请中' ? <Popconfirm
                                                        title="取消续租将需要重新申续,是否确认取消?"
                                                        onConfirm={() => { tapOnce(() => this.cancelAsurname(item.id, item.legacy)) }}
                                                        onCancel={() => { this.handleCancels() }}
                                                        visible={visible}
                                                        okButtonProps={{ loading: confirmLoading }}
                                                        okText="确定"
                                                        cancelText="取消"
                                                    >
                                                        <a href="#" onClick={() => { this.showPopconfirm() }} style={{ marginLeft: '10px' }}>取消</a>
                                                    </Popconfirm> : null}
                                                </div> : callbacksType == '2' && (item.evictionStatus == '待审核' || item.evictionStatus == '已驳回' || item.evictionStatus == '发起签章' || item.evictionStatus == '签章中' || item.evictionStatus == '签章成功') ?
                                                    <div>
                                                        {(item.evictionStatus == '待审核' || item.evictionStatus == '已驳回') ? <a onClick={() => { this.changeDrawback(item) }}>修改</a> : null}
                                                        {(item.evictionStatus == '发起签章' || item.evictionStatus == '签章中') ? <a onClick={() => { this.toSignature(item.id) }}>去签章</a> : null}
                                                        {(item.evictionStatus == '签章成功') ? <a onClick={() => { this.viewSignature(item.id) }} style={{ marginRight: '20px' }}>查看申退签章</a> : null}
                                                        {(item.inspectStatus == '签章成功') ? <a onClick={() => { this.viewSignatures(item.inspectId) }}>查看验房签章</a> : null}
                                                        {(item.evictionStatus == '待审核' || item.evictionStatus == '已驳回') ? <Popconfirm
                                                            title="取消退租将需要重新申退,是否确认取消?"
                                                            onConfirm={() => { tapOnce(this.calcelFun, item.id) }}
                                                            // onCancel={() => { this.handleCancels() }}
                                                            // visible={visible}
                                                            okButtonProps={{ loading: confirmLoading }}
                                                            okText="确定"
                                                            cancelText="取消"
                                                        >
                                                            <a href="#" onClick={() => { this.showPopconfirm() }} style={{ marginLeft: '10px' }}>取消退租</a>
                                                        </Popconfirm> : null}
                                                    </div> : null :
                                        null}
                                </Col>
                                {currest == '0' && callbacksType == '1' && (item.status === '已驳回' || item.status === '驳回') ?
                                    <Col>
                                        <Row>
                                            <Col span={24} className='hui'>驳回理由</Col>
                                            <Col span={24} className='hei'>{item.remark}</Col>
                                        </Row>
                                    </Col> :
                                    null
                                }
                                {currest == '0' && callbacksType == '2' && item.reason ?
                                    <Col>
                                        <Row>
                                            <Col span={24} className='hui'>驳回理由</Col>
                                            <Col span={24} className='hei'>{item.reason}</Col>
                                        </Row>
                                    </Col> :
                                    null
                                }
                            </Row>
                        </Card> : null}
                </Col>
                <Col span={24} className="setBlock" style={{ display: 'none' }}>
                    {this.state.sonObj.son == '0' ?
                        <Card bordered={false} bodyStyle={{ width: '100%', boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.16)', marginTop: '20px', padding: '0 24px 50px 24px' }}
                        >
                            <Row>
                                {callbacksType == '0' ?
                                    <Col span={24} style={{ lineHeight: '2em', fontSize: '20px' }} className={dt_4[currest].color}>
                                        <span>{dt_4[currest].key}</span>
                                    </Col> : callbacksType == '1' ?
                                        <Col span={24} style={{ lineHeight: '2em', fontSize: '20px' }} className={item.status === '申请中' ? 'lan' : item.status === '已签约' ? 'lv' : 'hui'}>
                                            <span>{item.status}</span>
                                        </Col> : callbacksType == '2' ?
                                            <Col span={24} style={{ lineHeight: '2em', fontSize: '20px' }} className={dt_4[currest].colors}>
                                                <span>{dt_4[currest].keys}</span>
                                            </Col> : null}
                                <Col span={24}>
                                    <Row>
                                        <Col span={9} className='hui'>
                                            {callbacksType == '0' ? dt_1[currest] : callbacksType == '1' ? '续租类型' : callbacksType == '2' ? '退租类型' : null}
                                        </Col>
                                        <Col span={15} >
                                            {callbacksType == '0' ? dt_4[currest].dt_1 : callbacksType == '1' ? item.reletType ? item.reletType : '暂无数据' : callbacksType == '2' ? item.evictionType ? item.evictionType : '暂无数据' : null}
                                        </Col>
                                        <Col span={9} className='hui'>
                                            {callbacksType == '0' ? dt_2[currest] : callbacksType == '1' ? '续租月份' : callbacksType == '2' ? '计划退租日' : null}
                                        </Col>
                                        <Col span={15} >
                                            {callbacksType == '0' ? dt_4[currest].dt_2 : callbacksType == '1' ? item.reletMonth ? item.reletMonth + '月' : '暂无数据' : callbacksType == '2' ? item.applyEvictionDate ? item.applyEvictionDate : '暂无数据' : null}
                                        </Col>
                                        <Col span={9} className='hui'>
                                            {callbacksType == '0' ? dt_3[currest] : callbacksType == '1' ? '续租合同类型' : callbacksType == '2' ? '退租理由' : null}
                                        </Col>
                                        <Col span={15} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100%' }}>
                                            {callbacksType == '0' ? dt_4[currest].dt_3 : callbacksType == '1' ? this.formatReletContractAttribute(item) : callbacksType == '2' ? item.evictionReason ? <span title={item.evictionReason}>{item.evictionReason}</span> : '暂无数据' : null}
                                        </Col>
                                        {item.transactionNoTitle ?
                                            <Col span={9} className='hui'>
                                                {item.transactionNoTitle}
                                            </Col> : null}
                                        {item.transactionNoTitle ?
                                            <Col span={15} >
                                                {item.transactionNo}
                                            </Col> : null}
                                        {item.copeWithTitle ?
                                            <Col span={9} className='hui'>
                                                {item.copeWithTitle}
                                            </Col> : null}
                                        {item.copeWithTitle ?
                                            <Col span={15} >
                                                {item.copeWith}
                                            </Col> : null}
                                        {item.contractNoTitle ?
                                            <Col span={9} className='hui'>
                                                {item.contractNoTitle}
                                            </Col> : null}
                                        {item.contractNoTitle ?
                                            <Col span={15} >
                                                {item.contractNo}
                                            </Col> : null}
                                        <Col span={9} className='hui'>
                                            {item.timesTitle}
                                        </Col>
                                        <Col span={15}>
                                            {item.times}
                                        </Col>
                                        {currest == '0' ?
                                            callbacksType == '0' ?
                                                <Row className='cardBottom'>
                                                    <Col style={{ borderLeft: '0px solid #C9D6FF' }}>
                                                        <a onClick={() => { tapOnce(this.showApply, item.id) }}>查看详情</a>
                                                    </Col>
                                                    {/* {item.perfectStatus == '0' ? <Col style={{ width: '70px' }}>
                                                        <a onClick={() => { this.setState({ showModalBox: true, ModalBoxId: item.id }) }} style={{ marginLeft: '10px' }}>
                                                            补全信息
                                                        </a>
                                                    </Col> : null} */}
                                                    {item.checkStatus == '驳回' ? <Col><a onClick={() => {
                                                        this.getTransactionDetailByIds(item.id)
                                                    }}><Divider type="vertical" />修改</a> </Col> : null}
                                                    {item.progress == '成功' ? <Col > <a href={item.addition} style={{ marginLeft: '10px' }} target='_blank'>下载</a></Col> :
                                                        null}
                                                    {(item.progress == '已复核' || item.progress == '已上传' || item.progress == '成功') && item.checkStatus != '驳回' ?
                                                        <Col ><a onClick={() => { this.printTransaction(item) }} style={{ marginLeft: '10px' }}>打印</a> </Col> :
                                                        null}
                                                    {(item.lackMaterialsFlag == '1' || item.lackMaterialsFlag == '2' || item.lackMaterialsFlag == '3') && item.smsCount > 0 && item.progress != '失败' ? <Col> <a onClick={() => { tapOnce(this.showMaterialMakeupBox, item) }} style={{ marginLeft: '10px' }} target='_blank'>补材料</a></Col> :
                                                        null}
                                                </Row> : callbacksType == '1' ?
                                                    <Row className='cardBottom'>
                                                        {item.status == '申请中' || (item.status == '驳回' && item.legacy == false) ? <Col style={{ borderLeft: '0px solid #C9D6FF' }}>
                                                            <a onClick={() => { this.showAsurnameBox(item, index) }}>修改</a>
                                                        </Col> : null}
                                                        {item.status == '申请中' ? <Popconfirm
                                                            title="取消续租将需要重新申续,是否确认取消?"
                                                            onConfirm={() => { tapOnce(() => this.cancelAsurname(item.id, item.legacy)) }}
                                                            onCancel={() => { this.handleCancels() }}
                                                            visible={visible}
                                                            okButtonProps={{ loading: confirmLoading }}
                                                            okText="确定"
                                                            cancelText="取消"
                                                        >
                                                            <a href="#" onClick={() => { this.showPopconfirm() }} style={{ lineHeight: '40px' }}>取消</a>
                                                        </Popconfirm> : null}
                                                    </Row> : callbacksType == '2' && (item.evictionStatus == '待审核' || item.evictionStatus == '已驳回' || item.evictionStatus == '发起签章' || item.evictionStatus == '签章中' || item.evictionStatus == '签章成功') ?
                                                        <Row className='cardBottom'>
                                                            {(item.evictionStatus == '待审核' || item.evictionStatus == '已驳回') ? <a onClick={() => { this.changeDrawback(item) }}>修改</a> : null}
                                                            {(item.evictionStatus == '发起签章' || item.evictionStatus == '签章中') ? <a onClick={() => { this.toSignature(item.id) }}>去签章</a> : null}
                                                            {(item.evictionStatus == '签章成功') ? <a onClick={() => { this.viewSignature(item.id) }}>查看申退签章</a> : null}
                                                            {(item.inspectStatus == '签章成功') ? <a onClick={() => { this.viewSignatures(item.inspectId) }}>查看验房签章</a> : null}
                                                            {(item.evictionStatus == '待审核' || item.evictionStatus == '已驳回') ? <Popconfirm
                                                                title="取消退租将需要重新申退,是否确认取消?"
                                                                onConfirm={() => { tapOnce(this.calcelFun, item.id) }}
                                                                // onCancel={() => { this.handleCancels() }}
                                                                // visible={visible}
                                                                okButtonProps={{ loading: confirmLoading }}
                                                                okText="确定"
                                                                cancelText="取消"
                                                            >
                                                                <a href="#" onClick={() => { this.showPopconfirm() }} style={{ lineHeight: '40px' }}>取消退租</a>
                                                            </Popconfirm> : null}
                                                        </Row>
                                                        : null : null}
                                        {currest == '1' ? (item.status == '已登记') || (item.status == '登记成功' && item.reserveStatus == '') ? <Row className='cardBottom'>
                                            <Popconfirm
                                                title="取消登记将重新进行登记,是否确认取消?"
                                                onConfirm={() => { tapOnce(this.handleOk, item.id) }}
                                                // onCancel={() => { this.handleCancels() }}
                                                // visible={visible}
                                                okButtonProps={{ loading: confirmLoading }}
                                                okText="确定"
                                                cancelText="取消"
                                            >
                                                <a href="#" onClick={() => { this.showPopconfirm() }} style={{ lineHeight: '40px' }}>取消登记</a>

                                            </Popconfirm>
                                            {item.status == '登记成功' && item.reserveStatus == '' ?
                                                <a onClick={() => {
                                                    let p = { projectName: item.projectName, projectNo: item.projectNo }
                                                    tapOnce(this.getProjectDetail, p)
                                                }}>&nbsp;预约看房</a> : null}

                                        </Row> : null : null}
                                        {currest == '2' ? item.status == '预约中' ? <div className='cardBottom'>
                                            <Popconfirm
                                                title="取消预约视为您放弃本套房源及取消您目前的登记状态，如需选择其他房源，需重新登记轮候，请谨慎操作。"
                                                onConfirm={() => { tapOnce(this.cancelReserve, item.id) }}
                                                // onCancel={() => { this.handleCancels() }}
                                                // visible={visible}
                                                okButtonProps={{ loading: confirmLoading }}
                                                okText="确定"
                                                cancelText="取消"
                                            >
                                                <a href="#" onClick={() => { this.showPopconfirm() }} style={{ lineHeight: '40px' }}>取消预约</a>
                                            </Popconfirm>
                                        </div> : null : null}
                                        {currest == '4' ? <div className='cardBottom'>
                                            <a style={{ lineHeight: '40px' }} onClick={() => { this.showContractInfo(item.contractNo) }}>查看详情</a>
                                            {!item.reletFlag ? <a onClick={() => { this.openRenewalApplyModalBox(item) }} style={{ lineHeight: '40px' }}>续租申请</a> : null}
                                            {(item.contractStatus == '2' || item.contractStatus == '21') && (!item.evictionStatus || item.evictionStatus == '已取消') && item.isFullMonth && !item.reletFlag ? <a onClick={() => {
                                                this.setState({ showDrawback: true, contractList: item });
                                            }} style={{ lineHeight: '40px' }}>申请退租</a> : null}
                                        </div> : null}
                                        {currest == '0' && callbacksType == '1' && (item.status === '已驳回' || item.status === '驳回') ?
                                            <Col span={24}>
                                                <Row>
                                                    <Col span={9} className='hui'>
                                                        驳回理由
                                                    </Col>
                                                    <Col span={15} >
                                                        {item.remark}
                                                    </Col>
                                                </Row>
                                            </Col> : null}
                                        {currest == '0' && callbacksType == '2' && item.reason ?
                                            <Col span={24}>
                                                <Row>
                                                    <Col span={9} className='hui'>
                                                        驳回理由
                                                    </Col>
                                                    <Col span={15} >
                                                        {item.reason}
                                                    </Col>
                                                </Row>
                                            </Col> : null}
                                    </Row>
                                </Col>
                            </Row>
                        </Card> : null
                    }
                </Col>
                {/*<Modal title="补全材料" visible={isMaterial} onCancel={() => { this.handleCancel() }} onOk={() => { this.repairMaterials() }} className="personalModal">*/}
                {/*    <div style={{ backgroundColor: '#fcf8e3' }}>*/}
                {/*        <h3>驳回原因：</h3>*/}
                {/*        <p dangerouslySetInnerHTML={{ __html: this.state.lackMaterialsReason ? this.state.lackMaterialsReason : '' }}></p>*/}
                {/*    </div>*/}
                {/*    {item.lackMaterialsFlag == '1' || item.lackMaterialsFlag == '3' ?*/}
                {/*        <div>*/}
                {/*            <span>主申请人居住证（若为单位整体租赁，须上传单位承诺书，格式为jpg或者png）</span>*/}
                {/*            {loadingss ? <CommonUploads serrArr={jzzImages} setCommonImages={this.setCommonImages} list={{ kind: '居住证', transactionAdditionType: '主申请人附件' }} /> : null}*/}
                {/*        </div> :*/}
                {/*        null}*/}
                {/*    {item.lackMaterialsFlag == '2' || item.lackMaterialsFlag == '3' ?*/}
                {/*        <div>*/}
                {/*            <span>社保缴纳证明（格式为jpg或者png）</span>*/}
                {/*            {loadingss ? <CommonUploads serrArr={sbImages} setCommonImages={this.setCommonImages} list={{ kind: '社保缴纳证明', transactionAdditionType: '主申请人附件' }} /> : null}*/}
                {/*        </div> :*/}
                {/*        null}*/}
                {/*</Modal>*/}
            </div >
        );
    }
    //收藏  收藏功能未完成
    collect = (item, index) => {
        return (
            <Col span={24} key={index}>
                <Card title={item.title} bordered={true} style={{ border: '1px solid #A0B5FB' }} headStyle={{ borderBottom: '1px solid #A0B5FB', padding: '0 24px', background: '#F3F6FF', color: '#999999', fontSize: '16px' }}>
                    <Row>
                        {/* <Col span={4} style={{ borderRight: '1px solid #DCE5FF', textAlign: 'center', lineHeight: '100px', fontSize: '26px' }} className={dt_4[currest].color}>
                            <span>{dt_4[currest].key}</span>
                        </Col> */}
                        <Col span={12} style={{ borderRight: '1px solid #DCE5FF' }}>
                            <Row style={{ fontSize: '16px', textAlign: 'center', padding: '21px 10px' }} gutter={[0, 8]}>
                                {/* <Col span={8} className='hui'>{dt_1[currest]}</Col>
                                <Col span={8} className='hui'>{dt_2[currest]}</Col>
                                <Col span={8} className='hui'>{dt_3[currest]}</Col>
                                <Col span={8} className='hei'>{dt_4[currest].dt_1}</Col>
                                <Col span={8} className='hei'>{dt_4[currest].dt_2}</Col>
                                <Col span={8} className='hei'>{dt_4[currest].dt_3}</Col> */}
                            </Row>
                        </Col>
                        <Col span={8} style={{ textAlign: 'center', lineHeight: '100px' }}>
                            <div><a href="/#">查看详情</a></div>
                        </Col>
                    </Row>
                </Card>
            </Col>
        );
    }

    //站内信
    message = (item, index) => {
        return (

            <Col span={24} key={index}>
                <Card title={item.title} className='setNone' bordered={true} style={{ border: '1px solid #A0B5FB' }} headStyle={{ borderBottom: '1px solid #A0B5FB', padding: '0 24px', background: '#F3F6FF', color: '#999999', fontSize: '16px' }}>
                    <Row>

                        <Col span={18} >
                            {item.content}
                        </Col>
                        <Col span={6} style={{ textAlign: 'center', lineHeight: '30px', padding: '20px' }}>
                            <div className={'hui'} style={{ border: '1px solid #eee', borderRadius: '5px' }}>{moment(item.createTime).format('LL')}</div>
                        </Col>
                    </Row>
                </Card>
                <Card title={item.title} className='setBlock ' bordered={false} bodyStyle={{ width: '100%', boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.16)', marginTop: '20px', padding: '0 24px 10px 24px' }}>
                    <Row>

                        <Col span={24} style={{ paddingBottom: '5px' }}>
                            {item.content}
                        </Col>
                        <Col span={24} >
                            <div className={'hui'} >{moment(item.createTime).format('YYYY-MM-DD')}</div>
                        </Col>
                    </Row>
                </Card>

            </Col>
        );
    }

    edit = (e) => {
        this.setState({
            isedit: true
        })
    }
    handleCancel = () => {
        this.setState({
            isModalVisible: false,
            isChangePassword: false,
            isChangeMobile: false,
            isMaterial: false,
            jzzImages: '',
            jzzImagesTmp: '',
            sbImages: '',
            sbImagesTmp: '',
            lackMaterialsFlag: ''
        })
    }
    sendNationCaptcha = async () => {
        const { isTap } = this.state
        if (this.refs.formRef.getFieldValue('mobile') && this.refs.formRef.getFieldValue('mobile') !== undefined) {
            if (isTap === false) {
                this.setState({ isTap: true })
                let reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
                if (!reg_tel.test(this.refs.formRef.getFieldValue('mobile'))) {

                    return
                }
                let opts = {}
                opts.mobile = this.refs.formRef.getFieldValue('mobile')
                let data = await sendNationCaptcha(opts)
                if (data?.code != 0) {
                    message.error(data?.message)
                } else {
                    this.timersBtn()
                }

            } else {
                message.error('请勿重复点击')
            }
        } else {
            message.error('请填写您的手机号码')
        }



    }
    getUpdateUser = async () => {
        if (this.refs.formRef.getFieldValue('mobile') && this.refs.formRef.getFieldValue('mobile') != undefined) {
            let reg_tel = /^[1][3,4,5,7,8,9][0-9]{9}$/
            if (!reg_tel.test(this.refs.formRef.getFieldValue('mobile'))) {
                message.error('请输入正确手机号')
                return
            }
            let opts = {}
            opts.mobile = this.refs.formRef.getFieldValue('mobile')
            opts.idno = this.props.userLoginInfo.idno;
            opts.username = this.props.userLoginInfo.username;
            opts.email = this.props.userLoginInfo.email;
            let data = await getUpdateUser(opts)
            console.log(data);
            if (data.code === 0) {
                message.success('修改手机号成功')
                let Info = JSON.parse(JSON.stringify(this.props.userLoginInfo))
                Info.mobile = opts.mobile
                this.props.saveLoginInfo(Info)
                this.getMyTransactionList('7')
            } else {
                message.error('修改手机号失败')
            }
        } else {
            message.error('请填写您的手机号码')
        }
        this.setState({
            isChangeMobile: false,
            isedit: false
        })
    }
    timersBtn = () => {
        this.timers = setInterval(() => {
            this.setState({
                timer: this.state.timer - 1
            })
            if (this.state.timer === 0) {
                clearInterval(this.timers)
                this.setState({
                    isTap: false,
                    timer: 60
                })
            }
        }, 1000)
    }
    ChangeMobile = () => {
        this.setState({
            isChangeMobile: true
        })
    }
    changePassword = () => {
        console.log(1);
        this.setState({
            isModalVisible: false,
            isChangePassword: true
        })
    }
    //个人资料
    personalMessage = (item, index) => {
        const { isedit } = this.state
        return (

            <Col span={24} key={index}>
                <Row className={'marginBottom-20'}>
                    <Col xs={6} sm={4} md={4} lg={4} xl={4}>用户头像</Col>
                    <Col xs={12} sm={16} md={16} lg={16} xl={16}>
                        <Avatar
                            shape="square"
                            size={{ xs: 32, sm: 40, md: 64, lg: 64, xl: 80, xxl: 100 }}
                            icon={<AntDesignOutlined />}
                        />
                    </Col>
                    <Col xs={6} sm={4} md={4} lg={4} xl={4}>
                        <div className={'lan'} onClick={this.edit} style={{ border: '1px solid #1890ff', borderRadius: '5px', textAlign: 'center' }}>编辑资料</div>
                    </Col>
                </Row>
                <Row className={'marginBottom-20'}>
                    <Col xs={6} sm={4} md={4} lg={4} xl={4}>用户姓名</Col>
                    <Col span={16}>
                        {item.username}
                    </Col>
                </Row>
                <Row className={'marginBottom-20'}>
                    <Col xs={6} sm={4} md={4} lg={4} xl={4}>身份证号</Col>
                    <Col span={16}>
                        {item.idno}
                    </Col>

                </Row>
                <Row className={'marginBottom-20'}>
                    <Col xs={6} sm={4} md={4} lg={4} xl={4}>手机号码</Col>
                    <Col span={16}>
                        <a style={{ marginRight: '20px' }}>{item.mobile}</a>
                        {isedit === true ? <a onClick={this.ChangeMobile}>修改手机号</a> : ''}
                    </Col>
                </Row>
                <Row>
                    <Col xs={6} sm={4} md={4} lg={4} xl={4}>账号密码</Col>
                    <Col span={16}>
                        <a style={{ marginRight: '20px' }}>******</a>
                        <a onClick={this.changePassword}>修改密码</a>
                    </Col>
                </Row>
            </Col>
        );
    }
    personalPush = (tab) => {
        this.setState({
            selectableTab: tab
        })
        this.getMyTransactionList(tab)
    }
    formatReletContractAttribute = (item) => {
        const raw = item?.contractAttribute ?? item?.applyAttruble
        if (raw == null || String(raw).trim() === '') return '暂无数据'
        const code = String(raw).trim().length === 1 && /^[0-9]$/.test(String(raw).trim())
            ? `0${String(raw).trim()}`
            : String(raw).trim()
        if (code === '01' || code === '03') return '个人'
        if (code === '02' || code === '05') return '单位'
        if (code === '个人' || code === '单位') return code
        return '暂无数据'
    }
    showAsurnameBox = (item, index) => {
        this.setState({
            showRenewalEditModalBox: true,
            reletApplyId: item.id,
            reletApplyItem: item,
            indexAsurname: index,
        })
    }
    changeDrawback = async (item) => {
        this.setState({
            showDrawback: true,
            drawbackIdList: item
        });
    }
    toSignature = async (id) => {
        let opts = {}
        opts.id = id
        opts.operator = this.props.userLoginInfo.idno
        const _self = this
        const data = await evictionElectronicSignature(opts)
        if (data.code == 0) {
            // _self.callbacks('2')
            window.open(data.data)
            message.success('操作成功')
        } else {
            message.error(data.message)
        }
    }
    viewSignature = async (id) => {
        let opts = {}
        opts.id = id
        opts.operator = this.props.userLoginInfo.idno
        const _self = this
        const data = await evictionElectronicSignatureUrl(opts)
        if (data.code == 0) {
            // _self.callbacks('2')
            let url = data.data.split(',')
            for (let i = 0; i < url.length; i++) {
                window.open(url[i])
            }
            message.success('操作成功')
        } else {
            message.error(data.message)
        }
    }
    viewSignatures = async (id) => {
        let opts = {}
        opts.id = id
        opts.operator = this.props.userLoginInfo.idno
        const _self = this
        const data = await evictionElectronicSignatureUrls(opts)
        if (data.code == 0) {
            // _self.callbacks('2')
            let url = data.data.split(',')
            for (let i = 0; i < url.length; i++) {
                window.open(url[i])
            }
            message.success('操作成功')
        } else {
            message.error(data.message)
        }
    }
    getReletStartTime = (value, index) => {
        let formValue = {}
        formValue.contractAttribute = value.contractAttribute
        this.setState({
            reletStartTime: moment(value.contractEndDate).add(1, 'd').format('YYYY-MM-DD'),
            indexAsurname: index,
            editAsurnameList: null
        }, () => {
            this.refs.showFlagRefs.setFieldsValue(formValue)
        })
    }
    getReletType = (value) => {
        if (value == '正常续租') {
            let formValue = this.refs.showFlagRefs.getFieldsValue()
            formValue.month = '24'
            this.refs.showFlagRefs.setFieldsValue(formValue)
            this.getMonth('24')
        }
        if (value == '六年期内过渡') {
            let formValue = this.refs.showFlagRefs.getFieldsValue()
            formValue.month = ''
            if (formValue.contractAttribute == '01' || formValue.contractAttribute == '05') {
                formValue.contractAttribute = '01'
            }
            if (formValue.contractAttribute == '03' || formValue.contractAttribute == '02') {
                formValue.contractAttribute = '03'
            }
            this.refs.showFlagRefs.setFieldsValue(formValue)
            this.getMonth('')
        }
        if (value == '第七年过渡' || value == '第八年过渡') {
            let formValue = this.refs.showFlagRefs.getFieldsValue()
            formValue.month = '12'
            if (formValue.contractAttribute == '01' || formValue.contractAttribute == '05') {
                formValue.contractAttribute = '01'
            }
            if (formValue.contractAttribute == '03' || formValue.contractAttribute == '02') {
                formValue.contractAttribute = '03'
            }
            this.refs.showFlagRefs.setFieldsValue(formValue)
            this.getMonth('12')
        }
        this.setState({
            reletType: value
        })
    }
    getMonth = (value) => {
        console.log(value);

        if (value) {
            let formValue = this.refs.showFlagRefs.getFieldsValue()
            formValue.reletEndTime = moment(this.state.reletStartTime).add(value, 'M').add(-1, 'd').format('YYYY-MM-DD')
            this.refs.showFlagRefs.setFieldsValue(formValue)
        } else {
            let formValue = this.refs.showFlagRefs.getFieldsValue()
            formValue.reletEndTime = ''
            this.refs.showFlagRefs.setFieldsValue(formValue)
        }
    }
    onFinishFailed = ({ values, errorFields, outOfDate }) => {
        message.error('提交失败，您有信息未填写')
    }
    ViewShow = () => {
        let { secondsGoTo } = this.state
        this.timer = setInterval(() => {
            secondsGoTo -= 1;
            this.setState({
                secondsGoTo: secondsGoTo,
                countdownText: secondsGoTo + 's'
            })
            if (secondsGoTo == 0) {
                this.setState({
                    showGoTo: false
                })
                this.props.history.push({ pathname: '/areatoraise', query: { type: undefined } })
                clearInterval(this.timer);
            }
        }, 1000);
    }
    onFinish = async (values) => {
        const { indexAsurname, transactionList, editAsurnameList } = this.state
        let opts = {}
        if (editAsurnameList) {
            opts = { ...editAsurnameList, ...values }
        } else {
            opts = values
            opts.reletApplyDate = moment().format('YYYY-MM-DD')
            opts.contractNo = transactionList[indexAsurname].contractNo
            opts.houseId = transactionList[indexAsurname].houseId
            opts.type = '1'
            opts.source = '2'
            opts.idno = this.props.userLoginInfo.idno
        }
        const _self = this
        let list = await applyReSignContract(opts)
        if (list.code === 0) {
            if (editAsurnameList) {
                _self.callbacks('1')
                message.success('操作成功')
            } else {
                if (values.reletType == '正常续租' || values.reletType == '六年期内过渡') {
                    this.setState({
                        showGoTos: true,
                        showGoTo: true,
                        showAsurname: false
                    })
                } else {
                    this.ViewShow()
                    this.setState({
                        showGoTo: true,
                        showAsurname: false
                    })
                }
                //  else if (values.reletType == '六年期内过渡') {
                //     this.setState({
                //         showImg: true,
                //         showAsurname: false
                //     })
                // }
                _self.getMyTransactionList('4')
            }
            this.setState({
                showAsurname: false
            })
            this.refs.showFlagRefs.resetFields();
        } else {
            message.error(list.message)
        }
    }
    changeShowModalBox = () => {
        this.setState({
            showModalBox: false
        })
    }
    openRenewalApplyModalBox = (contract) => {
        this.setState({ showRenewalModalBox: true, renewalContract: contract })
    }
    changeRenewalModalBox = () => {
        this.setState({ showRenewalModalBox: false, renewalContract: null })
    }
    changeRenewalEditModalBox = (refreshed) => {
        this.setState({ showRenewalEditModalBox: false, reletApplyId: null, reletApplyItem: null })
        if (refreshed) {
            this.callbacks('1')
        }
    }
    changeShowDrawback = () => {
        this.setState({
            showDrawback: false,
            contractList: null,
            drawbackIdList: null
        })
    }
    render() {
        const { userLoginInfo } = this.props
        // const { transactionList, currest } = this.state
        const { selectableTab, transactionList, currest, needFixed, isModalVisible, loading, personal, loginLoading, signView, timer, isChangePassword, isChangeMobile, sonObj, loadings, lackMaterialsFlag, jzzImages, jzzImagesTmp, loadingss, isMaterial, sbImages, sbImagesTmp, showAsurname, showGoTos, showGoTo, showImg, reletStartTime, reletType, showModalBox, showRenewalModalBox, renewalContract, showRenewalEditModalBox, reletApplyId, reletApplyItem, showDrawback, contractList, countdownText, ModalBoxId, tabsDisabled, indexAsurname, drawbackIdList } = this.state
        console.log("🚀 ~ file: index.js:1064 ~ Personal ~ render ~ lackMaterialsFlag:", lackMaterialsFlag)
        console.log(ModalBoxId)
        const lists = [
            '我的申请',
            '我的登记',
            '我的预约',
            '我的账单',
            '我的合同',
            // '我的收藏',
            '消息通知',
            '我的租情直通车',
            '个人资料'
        ]
        return (
            <div id='personal'>
                <Top personalPush={this.personalPush} />
                {showRenewalModalBox ? <ModalBox renewalApply renewalContract={renewalContract} changeRenewalModalBox={this.changeRenewalModalBox} /> : null}
                {showRenewalEditModalBox ? <ModalBox renewalApplyEdit reletApplyId={reletApplyId} reletApplyItem={reletApplyItem} changeRenewalEditModalBox={this.changeRenewalEditModalBox} /> : null}
                {showModalBox ? <ModalBox showModalBox={showModalBox} ModalBoxId={ModalBoxId} changeShowModalBox={this.changeShowModalBox} /> : null}
                {showDrawback ? <Drawback showDrawback={showDrawback} contractList={contractList} drawbackIdList={drawbackIdList} changeShowDrawback={this.changeShowDrawback} /> : null}
                <Modal
                    centered
                    visible={showImg}
                    onOk={() => { this.setState({ showImg: false }) }}
                    onCancel={() => { this.setState({ showImg: false }) }}
                    width={1000}
                    footer={null}
                >
                    <img style={{ width: '100%' }} src={require('../../assets/images/areatoraise-two.png').default}></img>
                </Modal>
                <div className='content' style={{ display: 'inline-block', width: '100%', marginTop: '6em' }}>
                    <div className="col-lg-2"></div>
                    <div className="col-lg-8">
                        <div style={{ paddingLeft: '7px', marginBottom: '1.8em' }} className='setNone'>
                            <Breadcrumb separator=">">
                                <Breadcrumb.Item>个人中心</Breadcrumb.Item>
                                <Breadcrumb.Item>{lists[currest]}</Breadcrumb.Item>
                            </Breadcrumb>
                        </div>
                        <div className='setBlock' style={{ display: 'none', fontWeight: 'bold', fontSize: '22px', lineHeight: '3em' }}>
                            {lists[currest]}
                        </div>
                        <Layout style={{ background: '#f9f9f9' }}>
                            <Lefter userLoginInfo={userLoginInfo} selectable={selectableTab ? selectableTab : '0'} getMyTransactionList={(e) => { tapOnce(this.getMyTransactionList, e, 500) }} />
                            <Content style={{ margin: '0 16px', background: '#fff' }}>
                                <div className="site-layout-background" style={{ padding: 24, minHeight: 360 }}>
                                    <div className="site-card-wrapper">
                                        {/* 右侧展示内容 */}
                                        {currest < 5 ? <Row gutter={[0, 24]}>
                                            {currest === '0' ? <Col span={24}>
                                                <Tabs defaultActiveKey="0" onChange={(e) => { tapOnce(this.callbacks, e, 0) }}>
                                                    <TabPane tab={'资格证'} key="0" disabled={tabsDisabled}></TabPane>
                                                    <TabPane tab={'续租'} key="1" disabled={tabsDisabled}></TabPane>
                                                    <TabPane tab={'退租'} key="2" disabled={tabsDisabled}></TabPane>
                                                </Tabs>
                                            </Col> : ''}
                                            {currest == '0' && sonObj.son == '2' ?
                                                <div>
                                                    {loadings ?
                                                        <Spin /> :
                                                        <Row gutter={[0, 24]}>
                                                            {sonObj.transactionDetail ? <Card bordered={true} style={{ border: '1px solid #A0B5FB' }} headStyle={{ borderBottom: '1px solid #A0B5FB', padding: '0 24px', background: '#F3F6FF', color: '#999999', fontSize: '16px' }}>
                                                                <Row>
                                                                    <Col>
                                                                        <Apply toson={this.state.sonObj} getChangeSons={this.getChangeSons} />
                                                                    </Col>
                                                                </Row>
                                                            </Card> : <Col span={24}><Empty style={{ height: '545px' }} /></Col>}
                                                        </Row>}
                                                </div> : ''}
                                            {currest == '4' && sonObj.son == '1' ?
                                                <div>
                                                    {loadings ?
                                                        <Spin /> :
                                                        <Row gutter={[0, 24]}>
                                                            {sonObj.contractInfos ? <Card bordered={true} style={{ border: '1px solid #A0B5FB' }} headStyle={{ borderBottom: '1px solid #A0B5FB', padding: '0 24px', background: '#F3F6FF', color: '#999999', fontSize: '16px' }}>
                                                                <Row>
                                                                    <Col>
                                                                        <ContractInfo toson={this.state.sonObj} getChangeSon={this.getChangeSon} />
                                                                    </Col>
                                                                </Row>
                                                            </Card> : <Col span={24}><Empty style={{ height: '545px' }} /></Col>}
                                                        </Row>
                                                    }
                                                </div> : ''}
                                            {currest == '0' || currest == '4' ?
                                                <div>
                                                    <Modal title="续租申请" visible={showAsurname} closable={true} maskClosable={false} footer={false} onCancel={() => { this.setState({ showAsurname: false }); this.refs.showFlagRefs.resetFields(); }}>
                                                        <Form
                                                            name="showFlagBox"
                                                            layout="horizontal"
                                                            scrollToFirstError={true}
                                                            ref={'showFlagRefs'}
                                                            // preserve={true}
                                                            labelCol={{ span: 6 }}
                                                            labelWrap={true}
                                                            colon={false}
                                                            className="showFlagBox-form"
                                                            onFinish={(e) => { tapOnce(this.onFinish, e, 500) }}
                                                            onFinishFailed={(e) => { tapOnce(this.onFinishFailed, e, 500) }}
                                                        >
                                                            <div id="application" style={{ borderLeft: '3px solid #1890FF', padding: '0 0 0 5px', fontSize: '14px', height: '16px', lineHeight: '16px', marginBottom: '24px' }}>续租申请</div>
                                                            <Row gutter={[48, 8]}>
                                                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                                    <Form.Item name='reletType' label='续租类型：'
                                                                        rules={[{ required: true, message: '', }]}>
                                                                        <Select placeholder="请选择" onChange={(value) => { this.getReletType(value) }}>
                                                                            <Option value='正常续租'>正常续租</Option>
                                                                            <Option value='六年期内过渡'>六年期内过渡</Option>
                                                                            <Option value='第七年过渡'>第七年过渡</Option>
                                                                            <Option value='第八年过渡'>第八年过渡</Option>
                                                                        </Select>
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                                    <Form.Item name='contractAttribute' label='续签合同类型：'
                                                                        rules={[{ required: true, message: '', }]}>
                                                                        {(transactionList[indexAsurname]?.contractAttribute == '01' || transactionList[indexAsurname]?.contractAttribute == '05') ?
                                                                            <Select placeholder="请选择">
                                                                                <Option value='01'>个人</Option>
                                                                                {(reletType == '正常续租' || reletType == '') ? <Option value='05'>单位</Option> : null}
                                                                            </Select> :
                                                                            <Select placeholder="请选择">
                                                                                <Option value='03'>个人</Option>
                                                                                {(reletType == '正常续租' || reletType == '') ? <Option value='02'>单位</Option> : null}
                                                                            </Select>}
                                                                    </Form.Item>
                                                                    <Col xs={24} sm={24} md={24} lg={24} xl={24} style={{ color: 'red' }} className='btmRedLeft'>
                                                                        <p>个人：</p>
                                                                        <p>1.合同乙方为主申请人，合同签署由本人签字。</p>
                                                                        <p>2.房屋租金由个人支付，发票抬头为个人抬头。</p>
                                                                    </Col>
                                                                    <Col xs={24} sm={24} md={24} lg={24} xl={24} style={{ color: 'red' }} className='btmRedRight'>
                                                                        <p>单位：</p>
                                                                        <p>1.合同乙方为申请人所在工作单位，合同签署由单位加盖合同章、法人章。</p>
                                                                        <p>2.房屋租金可由单位支付或个人支付，发票抬头均为单位抬头。</p>
                                                                        <p>3.可在单位及入住人同意后变更本单位其他持有保租房准入资格的员工入住。</p>
                                                                        <p>4.符合条件的特定情况下可申请安排同单位多名持有保租房准入资格的员工合租。</p>
                                                                    </Col>
                                                                </Col>
                                                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                                    <Form.Item name='month' label='续租月份：'
                                                                        rules={[{ required: true, message: '', }]}>
                                                                        {!reletType ?
                                                                            <Select placeholder="请选择" onChange={(value) => { this.getMonth(value) }}>
                                                                                <Option value="1">1月</Option>
                                                                                <Option value="2">2月</Option>
                                                                                <Option value="3">3月</Option>
                                                                                <Option value="4">4月</Option>
                                                                                <Option value="5">5月</Option>
                                                                                <Option value="6">6月</Option>
                                                                                <Option value="7">7月</Option>
                                                                                <Option value="8">8月</Option>
                                                                                <Option value="9">9月</Option>
                                                                                <Option value="10">10月</Option>
                                                                                <Option value="11">11月</Option>
                                                                                <Option value="12">12月</Option>
                                                                                <Option value="13">13月</Option>
                                                                                <Option value="14">14月</Option>
                                                                                <Option value="15">15月</Option>
                                                                                <Option value="16">16月</Option>
                                                                                <Option value="17">17月</Option>
                                                                                <Option value="18">18月</Option>
                                                                                <Option value="19">19月</Option>
                                                                                <Option value="20">20月</Option>
                                                                                <Option value="21">21月</Option>
                                                                                <Option value="22">22月</Option>
                                                                                <Option value="23">23月</Option>
                                                                                <Option value="24">24月</Option>
                                                                            </Select> : reletType == '正常续租' ?
                                                                                <Select placeholder="请选择" onChange={(value) => { this.getMonth(value) }}>
                                                                                    <Option value="24">24月</Option>
                                                                                </Select> : reletType == '六年期内过渡' ?
                                                                                    <Select placeholder="请选择" onChange={(value) => { this.getMonth(value) }}>
                                                                                        <Option value="1">1月</Option>
                                                                                        <Option value="2">2月</Option>
                                                                                        <Option value="3">3月</Option>
                                                                                        <Option value="4">4月</Option>
                                                                                        <Option value="5">5月</Option>
                                                                                        <Option value="6">6月</Option>
                                                                                        <Option value="7">7月</Option>
                                                                                        <Option value="8">8月</Option>
                                                                                        <Option value="9">9月</Option>
                                                                                        <Option value="10">10月</Option>
                                                                                        <Option value="11">11月</Option>
                                                                                        <Option value="12">12月</Option>
                                                                                    </Select> : reletType == '第七年过渡' || reletType == '第八年过渡' ?
                                                                                        <Select placeholder="请选择" onChange={(value) => { this.getMonth(value) }}>
                                                                                            <Option value="12">12月</Option>
                                                                                        </Select> : null}
                                                                        {/* {reletType == '正常续租' || !reletType ? <Select placeholder="请选择" onChange={(value) => { this.getMonth(value) }}>
                                                                            <Option value="1">1月</Option>
                                                                            <Option value="2">2月</Option>
                                                                            <Option value="3">3月</Option>
                                                                            <Option value="4">4月</Option>
                                                                            <Option value="5">5月</Option>
                                                                            <Option value="6">6月</Option>
                                                                            <Option value="7">7月</Option>
                                                                            <Option value="8">8月</Option>
                                                                            <Option value="9">9月</Option>
                                                                            <Option value="10">10月</Option>
                                                                            <Option value="11">11月</Option>
                                                                            <Option value="12">12月</Option>
                                                                            <Option value="13">13月</Option>
                                                                            <Option value="14">14月</Option>
                                                                            <Option value="15">15月</Option>
                                                                            <Option value="16">16月</Option>
                                                                            <Option value="17">17月</Option>
                                                                            <Option value="18">18月</Option>
                                                                            <Option value="19">19月</Option>
                                                                            <Option value="20">20月</Option>
                                                                            <Option value="21">21月</Option>
                                                                            <Option value="22">22月</Option>
                                                                            <Option value="23">23月</Option>
                                                                            <Option value="24">24月</Option>
                                                                        </Select> :
                                                                            reletType == '六年期内过渡' || reletType == '第七年过渡' || reletType == '第八年过渡' ? <Select placeholder="请选择" onChange={(value) => { this.getMonth(value) }}>
                                                                                <Option value="1">1月</Option>
                                                                                <Option value="2">2月</Option>
                                                                                <Option value="3">3月</Option>
                                                                                <Option value="4">4月</Option>
                                                                                <Option value="5">5月</Option>
                                                                                <Option value="6">6月</Option>
                                                                                <Option value="7">7月</Option>
                                                                                <Option value="8">8月</Option>
                                                                                <Option value="9">9月</Option>
                                                                                <Option value="10">10月</Option>
                                                                                <Option value="11">11月</Option>
                                                                                <Option value="12">12月</Option>
                                                                            </Select> : null} */}
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                                    <Form.Item name='reletStartTime' label='续租起始时间：'
                                                                        // rules={[{ required: true, message: '', }]}
                                                                        initialValue={reletStartTime}
                                                                    >
                                                                        <Input disabled />
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                                    <Form.Item name='reletEndTime' label='续租截止时间：'
                                                                    // rules={[{ required: true, message: '', }]}
                                                                    >
                                                                        <Input disabled />
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                                    <Form.Item name='reletReason' label='续租理由：'
                                                                    // rules={[{ required: true, message: '', }]}
                                                                    >
                                                                        <Input.TextArea />
                                                                    </Form.Item>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col span={24} style={{ borderTop: '1px solid #f0f0f0', textAlign: 'right', paddingTop: '10px' }}>
                                                                    <Button onClick={() => { this.setState({ showAsurname: false }); this.refs.showFlagRefs.resetFields(); }}>
                                                                        取消
                                                                    </Button>
                                                                    <Button type="primary" htmlType="submit" style={{ marginLeft: '10px' }}>
                                                                        确定
                                                                    </Button>
                                                                </Col>
                                                            </Row>
                                                        </Form>
                                                    </Modal>
                                                    <Modal visible={showGoTo} closable={showGoTos} maskClosable={showGoTos} footer={false} style={{ textAlign: 'center' }} onCancel={() => { this.setState({ showGoTo: false }); }}>
                                                        <p style={{ display: 'flex', justifyContent: 'center', padding: '24px 0' }}>
                                                            <img src={require('../../assets/images/showGoTo.png').default}></img>
                                                        </p>
                                                        <h1>提交成功</h1>
                                                        {showGoTos ? <p style={{ marginTop: '48px' }}><span style={{ color: 'red', marginRight: '5px' }}>续租请至随申办或一网通办申请，若两个平台均无法申请，
                                                            <br />
                                                            请致电56671727或56100661</span></p> : <p style={{ marginTop: '48px' }}><span style={{ color: '#1890FF', marginRight: '5px' }}>{countdownText}</span>后将跳转打开资格申请</p>}
                                                        {showGoTos ? '' : <Button type="primary" style={{ marginBottom: '48px' }} onClick={() => {
                                                            this.props.history.push({ pathname: '/areatoraise', query: { type: undefined } })
                                                        }}>立即前往</Button>}
                                                    </Modal>
                                                </div> : ''
                                            }
                                            {currest === '3' ? <Col span={24}>
                                                <Tabs defaultActiveKey="0" centered onChange={(e) => { tapOnce(this.callback, e, 1000) }}>
                                                    <TabPane tab="未缴费" key="0"></TabPane>
                                                    <TabPane tab="已缴费" key="1"></TabPane>

                                                </Tabs>
                                            </Col> : ''}
                                            {transactionList.length > 0 ? transactionList.map(this.tableBody) : <Col span={24}><Empty style={{ height: '545px' }} /></Col>}
                                        </Row> : ''}
                                        {/* {currest === '5' ? <Row gutter={[0, 24]}>
                                            {transactionList.length > 0 ? transactionList.map(this.collect) : <Col span={24}><Empty style={{ height: '545px' }} /></Col>}
                                        </Row> : ''} */}
                                        {currest === '5' ? <Row gutter={[0, 24]}>
                                            {transactionList.length > 0 ? transactionList.map(this.message) : <Col span={24}><Empty style={{ height: '545px' }} /></Col>}
                                        </Row> : ''}
                                        {currest === '6' ? <TenantDirectMyList /> : ''}
                                        {currest === '7' ? <Row gutter={[0, 24]}>
                                            {transactionList.length > 0 ? transactionList.map(this.personalMessage) : <Col span={24}><Empty style={{ height: '545px' }} /></Col>}
                                        </Row> : ''}
                                    </div>
                                </div>
                            </Content>
                        </Layout>
                    </div>
                    <div className="col-lg-2"></div>
                </div>
                <Footer />
                <Modal title="补全材料" visible={isMaterial} onCancel={() => { this.handleCancel() }} onOk={() => { tapOnce(this.repairMaterials) }} className="personalModal">
                    <div style={{ backgroundColor: '#fcf8e3' }}>
                        <h3>驳回原因：</h3>
                        <p dangerouslySetInnerHTML={{ __html: this.state.lackMaterialsReason ? this.state.lackMaterialsReason : '' }}></p>
                    </div>
                    {lackMaterialsFlag == '1' || lackMaterialsFlag == '3' ?
                        <div>
                            <span>主申请人居住证（若为单位整体租赁，须上传单位承诺书，格式为jpg或者png）</span>
                            {loadingss ? <CommonUploads serrArr={jzzImages} serrArrTmp={jzzImagesTmp} setCommonImages={this.setCommonImages} list={{ kind: '居住证', transactionAdditionType: '主申请人附件', type: '补材料' }} /> : null}
                        </div> :
                        null}
                    {lackMaterialsFlag == '2' || lackMaterialsFlag == '3' ?
                        <div>
                            <span>社保缴纳证明（格式为jpg或者png）</span>
                            {loadingss ? <CommonUploads serrArr={sbImages} serrArrTmp={sbImagesTmp} setCommonImages={this.setCommonImages} list={{ kind: '社保缴纳证明', transactionAdditionType: '主申请人附件', type: '补材料' }} /> : null}
                        </div> :
                        null}
                </Modal>
                <Modal title={"修改密码"} visible={isChangePassword} onCancel={() => { this.handleCancel() }} footer={[]} width={492} style={{ padding: '23px' }}>
                    <Form
                        name="basic"
                        labelCol={{ span: 8 }}
                        wrapperCol={{ span: 16 }}
                        initialValues={{ remember: true }}
                        onFinish={(e) => { tapOnce(this.setPassword, e) }}
                        ref={'formRef'}
                        autoComplete="off"
                    >
                        <Row>
                            <Col xs={{ span: 16, offset: 3 }} sm={{ span: 24, offset: 3 }} lg={{ span: 24, offset: 3 }}>
                                <Form.Item label="" name="mobile" rules={[{ required: true, message: '未输入手机号码!' }, { validator: this.testValidate }]}>
                                    <Input placeholder="手机号码" style={{ width: '100%', height: '40px' }} />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={{ span: 9, offset: 3 }} lg={{ span: 13, push: 3, offset: 0 }}>
                                <Form.Item label="" name="research" rules={[{ required: true, message: '请填写验证码!' }]}>
                                    <Input placeholder="验证码" style={{ width: '100%', height: '40px' }} />
                                </Form.Item>
                            </Col>
                            <Col xs={{ span: 9, offset: 2 }} lg={{ span: 6, offset: 0 }}>
                                {timer === 60 ? <Button style={{ width: '100%', height: '40px' }} onClick={() => { tapOnce(this.sendNationCaptcha) }}>获取验证码</Button>
                                    : <Button style={{ width: '100%', height: '40px' }} disabled={true}>{timer} S</Button>}
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={{ span: 16, offset: 3 }} sm={{ span: 24, offset: 3 }} lg={{ span: 24, offset: 3 }}>
                                <Form.Item label="" name="loginPwd" rules={[{ required: true, message: '请填写新密码!' }, { validator: this.testValidate }]}>
                                    <Input.Password placeholder="新密码" style={{ width: '100%', height: '40px' }} />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={{ span: 16, offset: 3 }} sm={{ span: 24, offset: 3 }} lg={{ span: 24, offset: 3 }}>
                                <Form.Item style={{ textAlign: 'center', lineHeight: '2em' }}>
                                    <Button type="primary" htmlType="submit" loading={loading} style={{ width: '100%', height: '48px', fontSize: '15px' }}>
                                        重设密码
                                    </Button>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Modal>
                <Modal title={"修改手机号"} visible={isChangeMobile} onCancel={() => { this.handleCancel() }} footer={[]} width={492} style={{ padding: '23px' }}>
                    <Form
                        name="basic"
                        labelCol={{ span: 8 }}
                        wrapperCol={{ span: 16 }}
                        initialValues={{ remember: true }}
                        onFinish={(e) => { tapOnce(this.getUpdateUser, e, 500) }}
                        ref={'formRef'}
                        autoComplete="off"
                    >
                        <Row>
                            <Col xs={{ span: 16, offset: 3 }} sm={{ span: 24, offset: 3 }} lg={{ span: 24, offset: 3 }}>
                                <Form.Item label="" name="mobile" rules={[{ required: true, message: '未输入手机号码!' }, { validator: this.testValidate }]}>
                                    <Input placeholder="手机号码" style={{ width: '100%', height: '40px' }} />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={{ span: 16, offset: 3 }} sm={{ span: 24, offset: 3 }} lg={{ span: 24, offset: 3 }}>
                                <Form.Item style={{ textAlign: 'center', lineHeight: '2em' }}>
                                    <Button type="primary" htmlType="submit" loading={loading} style={{ width: '100%', height: '48px', fontSize: '15px' }}>
                                        确认
                                    </Button>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Modal>
            </div>

        )
    }
    testValidate = (rule, value, callback) => {
        if (rule.field === 'mobile') {
            let reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
            if (!reg_tel.test(value)) {
                return callback('请填写有效手机号码');
            }
        }
        if (rule.field === 'username') {
            let reg_tel = /[A-Za-z0-9_\-\u4e00-\u9fa5]+/
            if (!reg_tel.test(value)) {
                return callback('请输入中文、英文、数字');
            }
        }
        if (rule.field === 'loginPwd') {
            let reg_tel = /^.*(?=.{8,})(?=.*\d)(?=.*[A-Z]{1,})(?=.*[a-z]{1,})(?=.*[!@#$%^&*?\(\)]).*$/
            if (!reg_tel.test(value)) {
                return callback('密码长度至少8位，至少1个大写字母、1个小写字母、1个数字和1个特殊字符!');
            }
        }
        if (rule.field === 'loginUser') {
            if (!value) {
                return callback('请填写证件号码');
            }
            let arr = []
            let flag = false
            arr.push(idCardValid(value).status)
            // arr.push(isHKCard(value).status)
            arr.push(isTWCard(value).status)
            arr.push(isPassPortCard(value).status)
            // arr.push(isOfficerCard(value).status)
            // arr.push(isAccountCard(value).status)
            if (arr.indexOf(1) == -1) {
                flag = true
            }
            if (flag == true) {
                return callback('证件号码不合规');
            }
        }
        return Promise.resolve();

    }
}

const mapStateToProps = (state) => {
    return {
        userLoginInfo: state.userLoginInfo,
    }
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        saveLoginInfo: (...args) => dispatch(actionWays.saveLoginInfo(...args)),
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(Personal)
